import { EuiText } from '@elastic/eui';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import FormRadioGroup from '../../../../../components/Form/FormRadioGroup';
import ItemDetailsCollaspibleNav from './ItemDetailsCollaspibleNav';
import { ReactComponent as RestaurantSettings } from '../../../../../assets/img/svg/RestaurantSettings.svg';

const ItemFeatureSection = () => {
    const isOutletMenu = useSelector((state) => state.menuReducer.isOutletMenu);
    const [isNavOpen, setIsNavOpen] = useState(false);
    const themeMode = useSelector((state) => state.theme.theme);

    return (
        <ItemDetailsCollaspibleNav
            cardTitle='Feature this item in cart'
            isNavOpen={isNavOpen}
            cardDescription={<EuiText size='s'>This item will be shown in the feature section page.</EuiText>}
            setIsNavOpen={setIsNavOpen}
            icon={<RestaurantSettings fill={themeMode === 'light' ? 'black' : 'white'} />}
        >
            <FormRadioGroup
                name='is_featured_item'
                disabled={isOutletMenu}
                options={[
                    {
                        id: 'is_featured_item_yes',
                        label: 'Yes',
                        value: 'is_featured_item_yes',
                    },
                    {
                        id: 'is_featured_item_no',
                        label: 'No',
                        value: 'is_featured_item_no',
                    },
                ]}
            />
        </ItemDetailsCollaspibleNav>
    );
};

export default ItemFeatureSection;
